import React from "react";
import PageTitle from "../../../Shared/PageTitle/PageTitle";
import Category from "./components/Category";

import "./Nettoyage.css";

const Nettoyage = () => {
  return (
    <>
      <PageTitle title={"Nettoyage"} currentPage={"Nettoyage"} />
      <Category />
    </>
  );
};

export default Nettoyage;
